import styled from '@emotion/styled'
import { colors, spacing } from '@retailer-platform/shared-components'

export const ScheduleCard = styled.div<{ disabled?: boolean }>(({ disabled }) => ({
  backgroundColor: disabled ? colors.GRAYSCALE.X20 : colors.GRAYSCALE.X10,
  borderRadius: '8px',
  border: `1px solid ${colors.GRAYSCALE.X80}`,
  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
  padding: spacing.X12,
  width: '500px',
  opacity: disabled ? 0.7 : 1,
  pointerEvents: disabled ? 'none' : 'auto',
}))

export const TabContainer = styled.div({
  display: 'flex',
  borderBottom: `1px solid ${colors.GRAYSCALE.X10}`,
  marginBottom: spacing.X12,
})

export const Tab = styled.button<{ isActive: boolean; disabled?: boolean }>(
  ({ isActive, disabled }) => ({
    padding: `${spacing.X12} ${spacing.X24}`,
    border: 'none',
    background: 'none',
    color: isActive ? colors.PRIMARY.REGULAR : colors.GRAYSCALE.X70,
    borderBottom: isActive ? `2px solid ${colors.PRIMARY.REGULAR}` : 'none',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: isActive ? 500 : 400,
    '&:hover': {
      color: colors.PRIMARY.REGULAR,
    },
  })
)

export const DisplayRow = styled.div({
  display: 'flex',
  alignItems: 'center',
  gap: spacing.X12,
  marginBottom: spacing.X8,
  '&:last-child': {
    marginBottom: 0,
  },
})

export const DisplayLabel = styled.div({
  minWidth: '120px',
  color: colors.GRAYSCALE.X80,
  fontSize: '14px',
  fontWeight: 500,
})

export const ScheduleDisplayBox = styled.div({
  backgroundColor: colors.PRIMARY.REGULAR,
  color: colors.GRAYSCALE.X0,
  padding: spacing.X12,
  borderRadius: '4px',
  fontSize: '14px',
  width: '300px',
})

export const ErrorMessage = styled.div({
  backgroundColor: '#FFEBEE',
  color: '#D32F2F',
  padding: spacing.X12,
  borderRadius: '4px',
  marginTop: spacing.X16,
  fontSize: '14px',
  display: 'flex',
  alignItems: 'center',
  gap: spacing.X8,
})

export const InputGroup = styled.div({
  display: 'flex',
  alignItems: 'center',
  gap: spacing.X8,
  marginTop: spacing.X16,
})

export const Label = styled.div({
  color: colors.GRAYSCALE.X80,
  fontSize: '14px',
  marginBottom: spacing.X8,
})

export const Section = styled.div({
  marginBottom: spacing.X24,
  '&:last-child': {
    marginBottom: 0,
  },
})
